<template>
  <v-container>
    <v-btn block size="large" color="primary" variant="flat" :disabled="disabled" @click="goToOrder">
      <v-icon class="mr-2">mdi-check</v-icon>
      {{ $t('order.execute') }}
    </v-btn>

    <login-dialog v-model:show="showLogin" @loggedIn="goToOrder"></login-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { ref, inject } from 'vue';
import { useRouter } from 'vue-router';
import LoginDialog from '@/venit/components/cortona-venit/components/login/LoginDialog.vue';
import AccountService from '@/account/account.service';

withDefaults(defineProps<{
  disabled?: boolean;
}>(), {
  disabled: true,
});

const router = useRouter();
const accountService = inject<() => AccountService>('accountService')!;

const showLogin = ref(false);

const goToOrder = () => {
  if (accountService().authenticated) {
    router.push({ name: 'user-order-page' });
  } else {
    showLogin.value = true;
  }
};
</script>

<style scoped></style>